import React, { useContext } from "react";
import "./styles";
import { ImageUploadCategoriaContainer, ModalCroppingContainer } from "./styles";
import { ImageUploadWithCrop } from "../ImageUploadWithCrop";
import { ReactComponent as Plus } from "../../../assets/newImages/icons/plus.svg";
import { ReactComponent as Loading } from "../../../assets/newImages/icons/rounded.svg";
import ModalRelativo from "../../ModalRelativo/ModalRelativo";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import Modal from "../../Modal/Modal";

interface ImageUploadCategoriaProps {
  value: string;
  onChange: (base64: string, imagem: string, size: number) => void;
  disabled? : boolean;
}

const ImageUploadCategoria: React.FC<ImageUploadCategoriaProps> = ({
  onChange,
  value,
  disabled = false
}) => {
  const { theme } = useTheme();

  const [loading, setLoading] = React.useState(false);

  return (
    <ImageUploadCategoriaContainer theme={theme}>
      <ImageUploadWithCrop
        onLoading={(loading) => {
          setLoading(loading);
        }}
        className={`logo-input-container-empresa ${disabled ? 'disabled-input' : ''}`}
        acceptFormats={".png, .jpeg, .jpg, .webp, .heic, .heif"}
        value={value}
        aspectRatio={1 / 1}
        onChange={onChange}
        circularCrop={true}
        resize={{ width: 150, height: 150 }}
        minWidth={150}
        minHeight={150}
        errorMargin={10}
        onOpenCrop={(cropping, cancelar, salvar) => (
          <Modal
            isOpen={true}
            setModal={() => {}}
            padding={"5rem 5rem"}
            width="auto"
          >
            <ModalCroppingContainer theme={theme}>
              <div className="titulo">Editar imagem</div>
              {cropping}
              <div className="botoes">
                {cancelar}
                {salvar}
              </div>
            </ModalCroppingContainer>
          </Modal>
        )}
      >
        <div className="logo-wrapper">
          {value ? (
            <img src={value} alt="logo" />
          ) : (
            <Plus width="3rem" height="3rem" />
          )}
        </div>
      </ImageUploadWithCrop>
    </ImageUploadCategoriaContainer>
  );
};
export default ImageUploadCategoria;
